import 'styled-components'

declare module 'styled-components' {
  export interface DefaultTheme {
    baseSize: string
    font: {
      primary: string
      secondary: string
    }
    color: {
      body: string
      global: string
      inverted: string
      light: string
      muted: string
      mutedInverted: string
      green: string
      dark: string
      primary: string
      primaryLight: string
      primaryDark: string
      primaryMedium: string
      secondary: string
      secondaryIntense: string
      line: string
      lemon: string
      lineInverted: string
      red: string
    }
    control: {
      sm: string
      md: string
      lg: string
    }
    grid: {
      outerMargin: string
      gutterWidth: string
    }
    spacing: {
      md: string
      sm: string
    }
    outerMargin: string
    size: {
      topBar: string
      bottomBar: string
    }
    contrastMode?: boolean
    accessibilityMode?: boolean
    fontSize: 'md' | 'lg' | 'xl'
  }
}

export const breakpoints = {
  xxs: 0,
  xs: 575,
  sm: 767,
  md: 991,
  lg: 1199,
  xl: 1439,
  xxl: 1829
}

const fontSizeObject = {
  md: '1.05vh',
  lg: '1.25vh',
  xl: '1.45vh'
}

const themeBase = {
  baseSize: fontSizeObject.md,
  font: {
    primary: '"Montserrat", sans-serif',
    secondary: '"Playfair Display", serif'
  },
  color: {
    body: '#ffffff',
    global: '#000000',
    inverted: '#ffffff',
    light: '#EFF3F8',
    muted: 'rgba(0,0,0,0.5)',
    mutedInverted: 'rgba(255,255,255,0.5)',
    green: '#0AB500',
    dark: '#000000',
    primary: '#2C3055',
    primaryLight: '#E2E3EF',
    primaryMedium: '#B1B3C6',
    primaryDark: '#1B2041',
    secondary: '#E5DAAC',
    secondaryIntense: '#D6C370',
    line: 'rgba(0,0,0,0.2)',
    lemon: '#FFF700',
    lineInverted: 'rgba(255,255,255,0.15)',
    red: '#C91900'
  },
  control: {
    sm: '2.2rem',
    md: '2.75rem',
    lg: '3.2rem'
  },
  grid: {
    outerMargin: '16px',
    gutterWidth: '16px'
  },
  spacing: {
    md: '6rem',
    sm: '4rem'
  },
  outerMargin: '8%',
  size: {
    topBar: '6rem',
    bottomBar: '7rem'
  }
}
const theme = ({
  contrastMode,
  fontSize,
  accessibilityMode
}: {
  accessibilityMode?: boolean
  contrastMode?: boolean
  fontSize: 'md' | 'lg' | 'xl'
}) => {
  let outerMargin = themeBase.outerMargin
  if (fontSize === 'lg') {
    outerMargin = '6%'
  } else if (fontSize === 'xl') {
    outerMargin = '4%'
  }
  let spacing = themeBase.spacing
  if (fontSize === 'lg') {
    spacing = {
      ...themeBase.spacing,
      md: '4rem',
      sm: '3rem'
    }
  } else if (fontSize === 'xl') {
    spacing = {
      ...themeBase.spacing,
      md: '3rem',
      sm: '2rem'
    }
  }
  const color = contrastMode
    ? {
        ...themeBase.color,
        global: themeBase.color.lemon,
        inverted: themeBase.color.lemon,
        light: '#111111',
        secondary: themeBase.color.lemon,
        secondaryIntense: themeBase.color.lemon,
        line: themeBase.color.lemon,
        lineInverted: themeBase.color.lemon,
        muted: themeBase.color.lemon,
        mutedInverted: themeBase.color.lemon,
        body: themeBase.color.dark,
        primary: themeBase.color.dark,
        primaryDark: themeBase.color.dark,
        primaryLight: themeBase.color.primaryLight,
        primaryMedium: themeBase.color.lemon
      }
    : themeBase.color

  return { ...themeBase, baseSize: fontSizeObject[fontSize], color, contrastMode, accessibilityMode, fontSize, outerMargin, spacing }
}
export default theme
